// extracted by mini-css-extract-plugin
export default {"breadcrumb_container":"breadcrumbs_breadcrumb_container__5Kx3h","pathname":"breadcrumbs_pathname__VeT--","active_text":"breadcrumbs_active_text__J9kHv"};